<div class="row view-task-activity" style="">
    <div class="col-md-12">
        <h3>Istorija aktivnosti na zadatku</h3>
    </div>
    <div class="col-md-12" style="padding: 0 30px;">
        <div class="col-md-12 no-padding mb-3" style="border: 1px solid #f0f0f7;">

            <div class="w-auto float-left no-padding">
                <app-avatar [avatarWidth]="30"></app-avatar>
            </div>
            <div class="col-md-10 no-padding"><input type="text" class="form-control form-control-sm no-border"
                                                     placeholder="+ tekst komentara"></div>

            <div class="col-md-1 float-right no-padding text-right">
                <i class="fa fa-paperclip mr-2"></i>
                <button class="btn btn-success btn-sm pull-right"><i class="fa fa-check"></i></button>
            </div>
        </div>
    </div>
    <div class="clearfix"></div>
    <div class="wd-task-timeline-block col-md-12">
        <div class="wd-task-timeline-content">

            <ul>

                <li>
                    <div class="wd-line"></div>
                    <div class="wd-task-timeline-item">
                        <div class="float-left">
                            <app-avatar [avatarWidth]="30"></app-avatar>
                        </div>

                        <div class="wd-task-timeline-title">Dražen Raičković estimated 1 hour <span
                                class="wd-task-timeline-time float-right">5h</span></div>

                        <div class="wd-task-timeline-description">DEscription</div>
                    </div>
                </li>
                <li>
                    <div class="wd-line"></div>
                    <div class="wd-task-timeline-item">
                        <div class="float-left">
                            <app-avatar [avatarWidth]="30"></app-avatar>
                        </div>

                        <div class="wd-task-timeline-title">Dražen Raičković estimated 1 hour <span
                                class="wd-task-timeline-time float-right">5h</span></div>

                        <div class="wd-task-timeline-description">DEscription</div>
                    </div>
                </li>
                <li>
                    <div class="wd-line"></div>
                    <div class="wd-task-timeline-item">
                        <div class="float-left">
                            <app-avatar [avatarWidth]="30"></app-avatar>
                        </div>

                        <div class="wd-task-timeline-title">Dražen Raičković estimated 1 hour <span
                                class="wd-task-timeline-time float-right">5h</span></div>

                        <div class="wd-task-timeline-description">DEscription</div>
                    </div>
                </li>

            </ul>
        </div>
    </div>
    <div class="clearfix"></div>

</div>